import {
  MAP_PIN_BOUNDS_PRECISION,
  MAP_PIN_CACHE_MAX_ENTRIES,
} from "./constants";

export const normalizeMapPinBounds = (bounds) => {
  if (!bounds) return null;

  const normalizedBounds = {
    south: Number(bounds.south),
    west: Number(bounds.west),
    north: Number(bounds.north),
    east: Number(bounds.east),
  };

  if (
    Object.values(normalizedBounds).some((value) => !Number.isFinite(value)) ||
    normalizedBounds.south >= normalizedBounds.north ||
    normalizedBounds.west >= normalizedBounds.east
  ) {
    return null;
  }

  const roundedBounds = Object.fromEntries(
    Object.entries(normalizedBounds).map(([key, value]) => [
      key,
      Number(value.toFixed(MAP_PIN_BOUNDS_PRECISION)),
    ])
  );

  if (
    roundedBounds.south >= roundedBounds.north ||
    roundedBounds.west >= roundedBounds.east
  ) {
    return normalizedBounds;
  }

  return roundedBounds;
};

export const getMapPinBoundsKey = (bounds) =>
  [bounds.south, bounds.west, bounds.north, bounds.east].join(",");

export const pruneMapPinCache = (cache) => {
  if (cache.size <= MAP_PIN_CACHE_MAX_ENTRIES) return;

  const oldestKey = cache.keys().next().value;
  if (oldestKey) cache.delete(oldestKey);
};
